import React, { useEffect, useState } from 'react';
import { FileIcon, ExternalLink } from 'lucide-react';
import { getReimbursementFileUrl } from '../../../Services/APIs/reimbursement';

const isImage = (url) => /\.(jpe?g|png)$/i.test(String(url || '').split('?')[0]);

// A file already stored on the member's Reimbursement. The bucket is private, so it is shown
// through a short-lived signed link fetched from the API (never the raw stored URL).
const StoredFile = ({ reimbursementId, field, index = 0, storedUrl, label }) => {
    const [url, setUrl] = useState(null);
    const [failed, setFailed] = useState(false);
    const image = isImage(storedUrl);

    useEffect(() => {
        let cancelled = false;
        getReimbursementFileUrl(reimbursementId, field, index)
            .then((response) => { if (!cancelled) setUrl(response.data?.data?.url || null); })
            .catch(() => { if (!cancelled) setFailed(true); });
        return () => { cancelled = true; };
    }, [reimbursementId, field, index]);

    if (failed) {
        return <p className="text-xs text-gray-400">{label}: could not load the current file.</p>;
    }
    if (!url) {
        return <div className="h-24 rounded-lg bg-gray-100 animate-pulse" aria-label={`Loading ${label}`} />;
    }
    if (image) {
        return <img src={url} alt={label} className="w-full max-h-40 object-contain rounded-lg border border-gray-200 bg-white" onError={() => setFailed(true)} />;
    }
    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-gray-200 rounded-lg px-3 py-2 text-xs text-gray-600 bg-white hover:bg-gray-50">
            <FileIcon className="w-4 h-4 flex-shrink-0" />
            <span className="truncate flex-1">Open current {label.toLowerCase()}</span>
            <ExternalLink className="w-3.5 h-3.5" />
        </a>
    );
};

export default StoredFile;
